import { TIMELINE_WORLD_HEIGHT_PX } from "../../view/WorldMetrics/metrics";

/** Character marker diameter (not tied to transport UI size). */
export const MARKER_DIAMETER = 132;

/** Gap between adjacent marker discs along the rail. */
export const MARKER_GAP = 44;

/**
 * Typical group radius, for fixed spacing that does not depend on who is there.
 * A real group's circle comes from markerCircleRadius.
 */
export const MARKER_CIRCLE_RADIUS = 156;

/** Top padding on `.timeline-character-marker` (0.65rem @ 16px). */
export const MARKER_CONTAINER_PAD_TOP_PX = 10.4;

export function markerPackStep(): number {
  return MARKER_DIAMETER + MARKER_GAP;
}

export function timelineAxisY(viewportHeight: number): number {
  return viewportHeight * 0.5;
}

/** Vertical center of the book rail in world CSS px (matches WebGPU axis). */
export function timelineRailAxisY(): number {
  return timelineAxisY(TIMELINE_WORLD_HEIGHT_PX);
}

/** Shift label anchor up so the disc center sits on the rail line. */
export function markerDiscAxisOffsetY(): number {
  return MARKER_CONTAINER_PAD_TOP_PX;
}
